<ng-container *ngIf="vm$ | async as vm">
  <div class="p-3">
    <div class="card-header-grid">
      <div class="input-group input-lined" role="search">
        <div class="input-group-text">
          <i role="img" class="fa fa-search text-muted" aria-hidden="true"></i>
        </div>
        <input
          class="form-control"
          type="search"
          placeholder="{{ 'general.search' | translate }}"
          attr.aria-label="{{ 'general.search' | translate }}"
          [(ngModel)]="filterTerm"
          (ngModelChange)="onSearch($event)"
        />
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <div class="btn-group ms-3" dropdown *ngIf="bulkActions?.length">
          <button
            class="btn btn-sm btn-white dropdown-toggle"
            type="button"
            dropdownToggle
            aria-controls="achievementBulkActions"
          >
            {{ 'general.actions' | translate }}
          </button>

          <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right"
            id="achievementBulkActions"
          >
            <li *ngFor="let bulkAction of bulkActions">
              <button
                class="dropdown-item"
                type="button"
                (click)="onClickBulkAction(bulkAction, vm.rows)"
              >
                {{ getBulkActionLabel(bulkAction) | translate }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <ng-container *ngIf="vm.isReady; else loadingTable">
      <table
        class="table table-borderless table-striped border-top mb-0 table-hover"
      >
        <thead class="table-light">
          <tr>
            <th
              scope="col"
              class="cursor-pointer"
              style="width: 60px"
              (click)="onToggleAllChecked(vm.rows)"
            >
              <input
                [checked]="allCheckedToggle"
                type="checkbox"
                class="form-check-input"
                attr.aria-label="{{ 'general.selectAll' | translate }}"
              />
            </th>
            <th scope="col" class="sticky-name-col">{{
              'general.name' | translate
            }}</th>
            <th scope="col" *ngFor="let question of vm.questions">
              {{ getQuestionLabel(question) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of vm.rows">
            <tr
              *ngIf="shouldShowRow(row.memberName)"
              class="cursor-pointer"
              (click)="openAdjustModal(row, vm.questions)"
            >
              <td
                (click)="$event.stopPropagation(); onCheckRow(row)"
                (keydown.enter)="$event.stopPropagation()"
                (keydown.space)="$event.stopPropagation()"
              >
                <input
                  [checked]="isRowChecked(row)"
                  type="checkbox"
                  class="form-check-input"
                  attr.aria-label="{{ 'wcag.selectThis' | translate }}"
                />
              </td>
              <td class="sticky-name-col">
                <button
                  type="button"
                  (keyup.enter)="openAdjustModal(row, vm.questions)"
                  class="visually-hidden-focusable btn btn-sm btn-soft-primary me-2"
                  >{{ 'general.edit' | translate }}</button
                >
                <span>{{ row.memberName }}</span>
              </td>
              <td *ngFor="let question of vm.questions">
                <ng-container
                  *ngIf="
                    getAnswerRating(row, question.id) !== null;
                    else noAnswer
                  "
                >
                  <div
                    class="btn-group"
                    [attr.aria-label]="
                      getAnswerRating(row, question.id) +
                      ' ' +
                      ('wcag.ratingStar' | translate)
                    "
                    role="img"
                  >
                    <span
                      *ngFor="let star of stars; let i = index"
                      class="btn px-1"
                    >
                      <i
                        class="fa-star lead"
                        role="img"
                        [ngClass]="{
                          'far text-muted':
                            i >= getAnswerRating(row, question.id),
                          'fa text-warning ':
                            i < getAnswerRating(row, question.id)
                        }"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                </ng-container>
                <ng-template #noAnswer>
                  <button
                    type="button"
                    class="btn btn-sm btn-soft-primary"
                    (click)="
                      $event.stopPropagation();
                      openAdjustModal(row, vm.questions)
                    "
                  >
                    {{ 'general.add' | translate }}
                  </button>
                </ng-template>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="vm.rows.length === 0">
            <td
              class="text-muted text-center py-3"
              [attr.colspan]="vm.questions.length + 2"
            >
              {{ 'general.noData' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>

  <ng-template #loadingTable>
    <div
      class="spinner-border my-5 mx-auto d-block"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
    >
      <span class="visually-hidden">{{ 'general.loading' | translate }}</span>
    </div>
  </ng-template>
</ng-container>
